
        var result = require("!!../../../../node_modules/css-loader/index.js!./article-subsalesgroup.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/settings/settings-base/article-subsalesgroup.component.css
// module id = 2394
// module chunks = 1